/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page-plans[_ngcontent-%COMP%]{padding:60px 0 25px}.cancel[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{text-align:center;color:#565656;font-weight:600;font-size:1rem;margin-bottom:50px}"];
export { styles as styles };
